// extracted by mini-css-extract-plugin
export default {"tableContainer":"noDataCustomDashboard_tableContainer__Phg0M","noData":"noDataCustomDashboard_noData__7fnnG"};